export interface ReleaseNote {
  version: string;
  date: string;
  title: string;
  features: string[];
  fixes: string[];
}

export const releaseNotesData: ReleaseNote[] = [
  {
    version: "v1.2.0",
    date: "October 5, 2026",
    title: "Profit Calculator & UX Enhancements",
    features: [
      "Updated Profit Calculator default values and smart TV count conversion logic.",
      "Added global contextual floating Help button.",
      "Added subtle Version History tracking and Release Notes UI.",
    ],
    fixes: [
      "Cleaned up redundant inline help buttons across Dashboard and Profile.",
      "Fixed scroll listener capturing for Global Help button hiding behavior."
    ]
  },
  {
    version: "v1.1.0",
    date: "September 28, 2026",
    title: "AI Dealer Insights & Reporting",
    features: [
      "Introduced AI Report generation for dealer performance.",
      "Added impersonation warning banner for Admin users.",
      "New store locator UI on the Dealer profile page."
    ],
    fixes: [
      "Resolved layout inconsistencies on the Sales Resources mobile view.",
      "Optimized loading state for the Dashboard welcome carousel."
    ]
  }
];
